import { encodeQuery } from '@jane/shared/util';

import type {
  BrandDiscountStatuses,
  UnreviewedProductsProps,
} from './user.types';

export const userUrls = {
  janeUser: () => '/whoami',
  userBrandDiscounts: (status: BrandDiscountStatuses) =>
    `/users/brand_discounts?status=${status}`,
  users: () => '/users',
  unreviewedProducts: (storeIds: number[]) =>
    encodeQuery('/users/unreviewed_products/', { store_id: storeIds }),
};

const BASE_KEY = 'jane';

export const userQueryKeys = {
  janeUser: () => [BASE_KEY, 'janeUser'],
  userBrandDiscounts: (
    userId: string | number | undefined,
    status: BrandDiscountStatuses
  ) => [BASE_KEY, userId, 'brandDiscounts', status],
  unreviewedProducts: ({ userId, storeIds }: UnreviewedProductsProps) => [
    BASE_KEY,
    userId,
    'unreviewedProducts',
    storeIds,
  ],
};
